
import { ReactNode } from "react";
import { LucideIcon } from "lucide-react";

interface SectionProps {
  title: string;
  description: string;
  icon: LucideIcon;
  children: ReactNode;
  viewAllLink?: string;
  viewAllText?: ReactNode;
}

export const ContentSection = ({
  title,
  description,
  icon: Icon,
  children,
  viewAllLink,
  viewAllText
}: SectionProps) => {
  return (
    <section className="w-full py-12 px-4 mx-auto">
      <div className="container mx-auto">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between mb-10">
          <div className="text-left mb-4 md:mb-0">
            <h2 className="text-3xl md:text-4xl font-bold mb-3">
              <span className="flex items-center gap-3">
                <Icon className="h-7 w-7 text-primary" />
                {title}
              </span>
            </h2>
            <p className="text-muted-foreground max-w-2xl">
              {description}
            </p>
          </div>
          
          {viewAllText && (
            <div className="mt-2 md:mt-0">
              {viewAllText}
            </div>
          )}
        </div>
        
        <div className="w-full overflow-x-visible">
          {children}
        </div>
      </div>
    </section>
  );
};
